import { Portal } from '@mui/material';

import { Notification } from '@ifs-gcp/components';

import { useNotificationStore } from '@/store/notificationStore';

import styles from './notifications.module.scss';

export const Notifications = () => {
  const notifications = useNotificationStore((state) => state.notifications);
  const removeNotification = useNotificationStore((state) => state.removeNotification);

  return (
    <Portal>
      <div className={styles.wrapper}>
        {notifications.map((notification) => (
          <Notification
            key={notification.id}
            {...notification}
            onClose={() => {
              removeNotification(notification.id);
            }}
          />
        ))}
      </div>
    </Portal>
  );
};
